/**
 * Utility functions for formatting data
 */

/**
 * Convert email to username
 * Example: "maulik.s@iqm.com" -> "Maulik S"
 */
export const emailToUsername = (email: string): string => {
  if (!email) return '';
  
  // Extract the local part (before @)
  const localPart = email.split('@')[0];
  
  // Split by dots and capitalize each part
  const parts = localPart.split('.');
  const username = parts
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
  
  return username;
};

/**
 * Format date to readable format
 * Example: "2024-01-01T00:00:00Z" -> "1/1/2024"
 */
export const formatDate = (dateString: string): string => {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  } catch {
    return dateString;
  }
};

/**
 * Format date and time
 * Example: "2024-01-01T10:30:00Z" -> "1/1/2024, 10:30 AM"
 */
export const formatDateTime = (dateString: string): string => {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    return date.toLocaleString();
  } catch {
    return dateString;
  }
};
